import React, { useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import Axios from 'axios';
import { get } from 'lodash';
import { API_HOST } from '../../consts';
import { useEffect } from 'react';
import RelatorioTurmaColumn from '../../components/RelatorioTurmaColumn';
import { toast } from 'react-toastify';
import ComplexBarChart from './ComplexBarChart';
import { ThemeContext } from '../../contexts/ThemeContext';
import { FilterRelatorioContext } from '../../contexts/FilterRelatorioProvider/Context';
import ReportProficiencyScalePageButtons from './ReportProficiencyScalePageButtons';

const ClassReportPage = () => {
  const [relatorioTurma, setRelatorioTurma] = useState();
  const [loading, setLoading] = useState(true);
  const titulo = [
    'Linguagens, Códigos e suas Tecnologias',
    'Matemática e suas Tecnologias',
    'Ciências da Natureza e suas Tecnologias',
    'Ciências Humanas e suas Tecnologias'
  ];
  const [etapaData, setEtapaData] = useState();
  const [AnoData, setAnoData] = useState();
  const [PeriodoData, setPeriodoData] = useState();
  const theme = useContext(ThemeContext);
  const { filtrosRelatorios, setStateFilters } = useContext(FilterRelatorioContext)

  const fetchEtapaData = () =>
    Axios.get(`${API_HOST}/avalia/etapa?nr_etapa=${filtrosRelatorios.dadosEtapaEscolar}`)
      .then((res) => {
        setEtapaData(res.data.results[0]);
        fetchAnoData();
        fetchPeriodo();
      })
      .catch((err) => console.error(err));

  const fetchAnoData = () =>
    Axios.get(`${API_HOST}/avalia/ano?id=${1}`)
      .then((res) => {
        setAnoData(res.data);
      })
      .catch((err) => console.error(err));

  const fetchPeriodo = () =>
    Axios.get(`${API_HOST}/avalia/periodo?id=${filtrosRelatorios.periodoAno} `)
      .then((res) => {
        setPeriodoData(res.data);
      })
      .catch((err) => console.error(err));

  const fetchrelatorioTurma = () => {
    Axios.get(
      `${API_HOST}/avalia/boletim_mt/student_list?CD_ESCOLA=${filtrosRelatorios.currentEscola}&NR_ETAPA=${filtrosRelatorios.dadosEtapaEscolar}&CD_DISCIPLINA=${filtrosRelatorios.DisciplinaID}&PERIODO_ANO_ID__id=${filtrosRelatorios.periodoAno}`
    )
      .then((res) => {
        setRelatorioTurma(res.data);
        fetchEtapaData();
        setLoading(false);
      })
      .catch((err) =>
        toast.error('Não existem dados para a consulta realizada')
      );
  };

  useEffect(() => {
    fetchrelatorioTurma();
  }, []);

  return (
    <>
      <div
        className="card-header"
        style={{
          width: '100%',
          marginBottom: '-0.7rem',
          backgroundColor: '#f7f7f7',
          borderRadius: '10px'
        }}
      >
        <h1
          style={{
            fontFamily: 'Quicksand',
            fontSize: '24px',
            color: '#292929',
            fontWeight: 'bold'
          }}
        >
          Relatório por Série/Ano Escolar
        </h1>
        <span
          style={{
            fontSize: '14px',
            color: '#292929',
            fontWeight: 500,
            fontFamily: 'Quicksand'
          }}
        >
          Notas e proficiência dos estudantes
        </span>
        <hr
          style={{
            background: '#bebebe',
            width: '100%',
            height: '1px',
            borderRadius: '1px'
          }}
        />
      </div>
      <div
        className="card-body"
        style={{
          width:'100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <div
          className="input-type-style"
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column'
          }}
        >
          <ComplexBarChart
            tituloCompleto={
              'Desempenho médio da Série/Ano por área do conhecimento'
            }
            tipo={'etapa'}
            escola={filtrosRelatorios.currentEscola}
            etapa={filtrosRelatorios.dadosEtapaEscolar}
            ano={filtrosRelatorios.periodoAno}
          />
        </div>
        <div>
          <h1
            style={{
              fontWeight: 'bold',
              color: `${(props) => props.theme.primary}`
            }}
          >
            {
              titulo[
              relatorioTurma
                ? get(relatorioTurma[0], 'CD_DISCIPLINA') - 1
                : ''
              ]
            }
          </h1>
        </div>
        {loading ? (
          <div
            style={{
              width: '100%',
              height: `100%`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <img
              src={theme.loadingGif}
              alt="loading"
              style={{ height: '50px' }}
            />
          </div>
        )
          : (
            <>
              <RelatorioTurmaColumn
                disciplina={
                  titulo[
                  relatorioTurma
                    ? get(relatorioTurma, '[0].CD_DISCIPLINA') - 1
                    : ''
                  ]
                }
                prova={PeriodoData}
                relatorios={relatorioTurma}
                periodo={filtrosRelatorios.periodoAno}
                tituloCompleto="Nível de Proficiência do Estudante por Série Escolar"
              />
            </>
          )}

      </div>
      <ReportProficiencyScalePageButtons />
    </>
  );
};

export default withRouter(ClassReportPage);